// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__orKW6","loader__beer":"Loader_loader__beer__LSM+2","fill":"Loader_fill__qJoMz","loader__text":"Loader_loader__text__j8IQ3"};